import React, { useEffect, useState } from 'react';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import { FaCheck } from "react-icons/fa6";
import TextField from "./TextField";

interface Props {
    hasSearch?: boolean;
    label: string;
    placeholder?: string;
    type?: string;
    value: any[];
    options: { value: any; text: string }[];
    setValue: (value: any[]) => void;
}

function MultiSelectField(props: Props) {
    const [query, setQuery] = useState('');
    const options = props.options.filter(item => props.value.includes(item.value));
    const [filteredOptions, setFilteredOptions] = useState<{ value: any; text: string }[]>([]);

    useEffect(() => {
        if (props.hasSearch && query) {
            setFilteredOptions(props.options.filter(item => item.text.includes(query)));
        }
    }, [query]);

    return (
        <div className="select-field">
            <div className="label">{props.label}</div>
            <Listbox value={props.value} onChange={props.setValue} multiple>
                <ListboxButton className="picker-button">
                    {options.map(o => o.text).join(', ') || props.placeholder}
                </ListboxButton>
                <ListboxOptions
                    className="menu-box"
                    anchor="bottom"
                    transition
                >
                    {props.hasSearch ? <TextField value={query} setValue={setQuery} placeholder="Search" /> : null}
                    {
                        (query ? filteredOptions : props.options).map(item => (
                            <ListboxOption
                                className="menu-item"
                                key={item.value}
                                value={item.value}
                            >
                                <div style={{display: 'flex', justifyContent: 'space-between', gap: '8pc'}}>
                                    <span>{item.text}</span>
                                    {props.value.includes(item.value) ? <FaCheck /> : null}
                                </div>
                            </ListboxOption>
                        ))
                    }
                </ListboxOptions>
            </Listbox>
        </div>
    );
}

export default MultiSelectField;
